<!-- Jumbotron -->
<div *ngIf="loading" class="loading-indicator">
  <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
</div>

<div id="divLogin" class="flexContainer" style="visibility: collapse;">
    <!--<div class="purpleBorder"></div>-->
    <div class="padd15">
      <div width="250" alt="Thomson Reuters" class="trIcon"></div>

    <div class="LoginContainer" #fixheight>
      <div class="txtCenter">
        <h1 class="card-title">{{InstanceTitle}}</h1>
        <p class="card-title">{{InstanceInfo}}</p>
      </div>
      <p class="margTop40" id="acc_instanceurl">{{InstanceLabel}}</p>
      <form (ngSubmit)="btnConnectClick()">
        <div id="divLoginInstance" class="instanceLogin">
          <input id="url" type="url" aria-label="Enter your instance URL" class="form-control InstanceTextBox" aria-labelledby="acc_instanceurl" placeholder="{{InstanceInputPlaceholder}}">
          <button mat-raised-button id="connect" type="submit" aria-label="Connect" class="margTop15 msTeam-btn ">{{ButtonText}}</button>
        </div>
      </form>
      <div id="Error" class="ErrorMessage" *ngIf="ErrorVisible">{{InstanceErrorMessage}}</div>
      <div class="greyBg margTop15">{{InstanceBannerMessage}}</div>
    </div>
    <div class="fixedBott" #scrollheight>
      <div class="KnowledgeContainertop">
        {{HighQDemoText}}<a id="getHighQDemo" aria-label="HighQ Demo" href="{{HighQDemoLink}}" target="_blank">{{HighQDemoLinkText}}</a>{{HighQDemoTextEnd}}
      </div>
      <div class="KnowledgeContainer">
        {{LoginKBNoteText}}<a id="getKCHelp" aria-label="Knowledge base" href="{{KnowledgebaseLink}}" target="_blank">{{LoginKBNoteLinkText}}</a>
      </div>
    </div>
  </div>

</div>


